module.exports = __webpack_public_path__ + "img/profile-avatar.9acfe78b.png";